module.exports = [
    { text:"Is Exactly", value:"eq" },
    { text:"Contains", value:"contains" },
    { text:"Is Negative", value:"negative" },
];